// Shared coercion for API error `detail`. The backend's `detail` is USUALLY a string,
// but FastAPI 422 validation returns a list of error objects and some endpoints (e.g. the
// advisor daily cap) return a structured object. Rendering those directly produces
// "[object Object]" or throws on `.trim()`. This is the durable, single-place fix for the
// whole non-string-detail class (Pattern A) — every error surface should read detail
// through here.
export function coerceDetailMessage(detail: unknown): string {
  if (typeof detail === "string") return detail;
  // FastAPI 422: [{ msg, loc, type }, ...]
  if (Array.isArray(detail)) {
    const first = detail[0] as { msg?: unknown } | undefined;
    return first && typeof first.msg === "string" ? first.msg : "";
  }
  // Structured detail, e.g. the advisor daily-cap { code, message, reset_at }.
  if (detail && typeof detail === "object") {
    const msg = (detail as { message?: unknown }).message;
    if (typeof msg === "string") return msg;
  }
  return "";
}
